import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { TableData } from 'app/models/table-data';
import {
  TableViewData,
  TableViewDataGenerator,
  TableViewService,
} from './table-view.service';

class TableViewParams {
  scrollbarWidth: number;
  headerColumnWidths: number[];

  constructor(
    headerColumns: HTMLTableCellElement[],
    tableBodyContainer: HTMLDivElement,
    tableBody: HTMLTableCellElement
  ) {
    this.scrollbarWidth =
      tableBodyContainer.offsetWidth - tableBodyContainer.clientWidth;

    this.headerColumnWidths = [];

    const numHeaderColumns = headerColumns.length;
    const lastColumnIndex = numHeaderColumns - 1;

    for (let i = 0; i < numHeaderColumns; i++) {
      const bodyColumn = tableBody.querySelector(
        `tbody tr td:nth-child(${i + 1})`
      )! as HTMLTableCellElement;

      let headerColumnWidth = bodyColumn.offsetWidth;

      if (i == lastColumnIndex) {
        headerColumnWidth += this.scrollbarWidth;
      }

      this.headerColumnWidths.push(headerColumnWidth);
    }
  }
}

@Component({
  selector: 'app-table-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table-view.component.html',
  styleUrl: './table-view.component.scss',
})
export class TableViewComponent implements OnInit, OnChanges {
  @ViewChildren('headerColumn') headerColumns?: QueryList<
    ElementRef<HTMLElement>
  >;
  @ViewChild('tableBodyContainer') tableBodyContainer?: ElementRef<HTMLElement>;
  @ViewChild('tableBody') tableBody?: ElementRef<HTMLElement>;

  @Input() data?: TableData;

  private dataGenerator: TableViewDataGenerator;

  tableViewData: TableViewData = {
    columnsHeaders: [],
    displayedColumns: [],
    displayedRows: [],
  };

  constructor(tableViewService: TableViewService) {
    this.dataGenerator = tableViewService.getTableViewDataGenerator();
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.rebuildTableViewData();
    }
  }

  private rebuildTableViewData(): void {
    this.tableViewData = this.dataGenerator.getTableViewData(this.data);

    setTimeout(() => {
      this.setColumnWidths();
    }, 1);
  }

  onResize(): void {
    this.setColumnWidths();
  }

  private setColumnWidths(): void {
    if (!this.headerColumns || !this.tableBodyContainer || !this.tableBody) {
      setTimeout(() => {
        this.setColumnWidths();
      }, 500);
      return;
    }

    const headerColumns = this.headerColumns.map(
      (headerColumn) => headerColumn.nativeElement as HTMLTableCellElement
    );

    const params = new TableViewParams(
      headerColumns,
      this.tableBodyContainer.nativeElement as HTMLDivElement,
      this.tableBody.nativeElement as HTMLTableCellElement
    );

    headerColumns.forEach((headerColumn, index) => {
      headerColumn.style.width = `${params.headerColumnWidths[index]}px`;
    });
  }
}
